export const guaranteeSize = (size: string, threshold?: number): string =>
  parseInt(size, 10) < (threshold || 0) ? threshold + '' || '0' : size;
